import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Settings, Trash2 } from 'lucide-react';

const SortableComponent = ({ component, onSelect, onDelete, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: component.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative group border-2 border-transparent hover:border-primary/30 rounded-lg transition-colors ${
        isDragging ? 'z-50' : ''
      }`}
    >
      {/* Component Toolbar */}
      <div className="absolute -top-8 left-0 right-0 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-between bg-white shadow-md rounded-t-lg px-2 py-1 z-10">
        <div className="flex items-center gap-2">
          <button
            {...attributes}
            {...listeners}
            className="cursor-grab active:cursor-grabbing p-1 hover:bg-gray-100 rounded"
          >
            <GripVertical size={16} className="text-gray-400" />
          </button>
          <span className="text-xs font-medium text-gray-600">{component.type}</span>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => onSelect(component)}
            className="p-1 hover:bg-gray-100 rounded text-gray-500 hover:text-primary"
          >
            <Settings size={14} />
          </button>
          <button
            onClick={() => onDelete(component.id)}
            className="p-1 hover:bg-gray-100 rounded text-gray-500 hover:text-red-500"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>

      {/* Component Content */}
      <div className="p-2">
        {children}
      </div>
    </div>
  );
};

export default SortableComponent;
